import { render } from "./ModalBodyForFilm.vue?vue&type=template&id=9c4259c8&scoped=true"
import script from "./ModalBodyForFilm.vue?vue&type=script&lang=js"
export * from "./ModalBodyForFilm.vue?vue&type=script&lang=js"

import "./ModalBodyForFilm.vue?vue&type=style&index=0&id=9c4259c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4259c8"]])

export default __exports__